import creator from "../creator";

export default function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}



//////////////////
// WEBPACK FOOTER
// /home/daniel/www/navigator.palladium.cz/node_modules/d3-selection/src/selection/append.js
// module id = ../../../node_modules/d3-selection/src/selection/append.js
// module chunks = 0